module.exports = __webpack_public_path__ + "static/media/python.25c1ff13.png";